<template>

    <main class="gmp-page gmp-page--no-newsletter">
        <PICK_subpagehero />
        <PICK_two_column_text />
        <PICK_two_column_fullbleed />

    </main>

</template>


<script>
    import PICK_subpagehero from "../../../components/content/member/benefit/PICK_subpagehero";
    import PICK_two_column_text from "../../../components/content/member/benefit/PICK_two_column_text";
    import PICK_two_column_fullbleed from "../../../components/content/member/benefit/PICK_two_column_fullbleed";


    export default {
        name: 'PICK_Benefit',
        components:{
            PICK_subpagehero,
            PICK_two_column_text,
            PICK_two_column_fullbleed,

        }

    }


</script>

<style>



</style>